import React from 'react';

import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import SecurityCheckStatusLabelChip from 'components/chip/SecurityCheckStatusLabelChip';
import { SecurityCheckResultListItem } from 'stores/SecurityCheckStoreAdapter';

type Props = {
  item: SecurityCheckResultListItem;
};

const SecurityCheckListItem: React.FC<Props> = ({ item }) => {
  const isCompleted = item.resultCode !== null;

  return (
    <ListItemText
      primary={
        <Stack direction="row" alignItems="center" justifyContent="space-between" component="span">
          <Typography
            variant="body2"
            fontWeight={500}
            noWrap
            component="span"
            sx={{ flex: 1, minWidth: 0 }}
          >
            {item.title}
          </Typography>
          <SecurityCheckStatusLabelChip status={isCompleted ? 'COMPLETED' : 'NOT_STARTED'} />
        </Stack>
      }
      secondary={
        item.assessmentName ? (
          <Typography variant="caption" color="text.secondary" component="span">
            {item.assessmentName} {item.managementNumber1 || ''}
          </Typography>
        ) : undefined
      }
      sx={{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
    />
  );
};

export default SecurityCheckListItem;
